import React, {useState, useEffect} from 'react';
import { Text } from 'react-native';
import { Parse } from 'parse';

export const LastUpdateDate = ({ style }) => {
  const [date, setDate] = useState('');

  useEffect(async () => {
    try {
      const config = await Parse.Config.get();
      const dateUpdate = config.get('dateUpdate');
      setDate(dateUpdate);
    } catch (e) {
      //TODO сделать обработку
      console.log('ошибка Parse servera: ', e.message);
    }
  });

  return (
    <Text style={style}>
      Официальные вопросы Ростехнадзора на 2025 год.
      {'\n'}
      {!!date && `Последняя дата обновления: ${date}г.`}
    </Text>
  );
};
